<template>
  <v-dialog v-model="details" width="900" scrollable>
    <v-card height="550">
      <v-card-title class="headline grey lighten-2">
        View Details of Referred Users
      </v-card-title>
      <v-card-text style>
        <v-row class="m-0">
          <v-col cols="4">
            <label for>Date Range</label>
            <datepicker
              v-model="dateRange"
              @input="dateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD-MM-YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <tr>
                  <td>
                    <input
                      :value="inputValue.start"
                      v-on="inputEvents.start"
                      class="form-control"
                      placeholder="DD-MM-YYYY"
                    />
                  </td>
                  <td>
                    <input
                      :value="inputValue.end"
                      v-on="inputEvents.end"
                      class="form-control"
                      placeholder="DD-MM-YYYY"
                    />
                  </td>
                </tr>
              </template>
            </datepicker>
          </v-col>
        </v-row>
        <loader v-if="showLoader"></loader>
        <v-col cols="12">
          <div class="table-div">
            <table class="table table-responsive">
              <thead>
                <tr class="table-success">
                  <th scope="col">Date of joining</th>
                  <th scope="col">Role</th>
                  <th scope="col">Referred username</th>
                  <th scope="col">Referred code</th>
                  <th scope="col">Points received</th>
                  <th scope="col">Expiry Date</th>
                  <th scope="col">Subscription</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(list, i) in referencedUserList" :key="i">
                  <td>
                    <div>
                      {{ dayJS(list.createdAt).format(formats.date_format) }}
                    </div>
                  </td>
                  <td>
                    <div>
                      {{
                        list.completed_profiles
                          ? list.completed_profiles[0]
                          : "&#8213;"
                      }}
                    </div>
                  </td>
                  <td>
                    <div>{{ list.full_name }}</div>
                  </td>
                  <td>
                    <div>{{ list.referenced_by.code_used }}</div>
                  </td>
                  <td>
                    <div>
                      {{
                        list.referenced_by.points_received
                          ? list.referenced_by.points_received
                          : "&#8213;"
                      }}
                    </div>
                  </td>
                  <td>
                    <div>
                      {{
                        list.referenced_by.expiry
                          ? dayJS(list.referenced_by.expiry).format(
                              formats.date_format
                            )
                          : "&#8213;"
                      }}
                    </div>
                  </td>
                  <td>
                    <div>&#8213;</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="isEmpty">
                <tr>
                  <td colspan="6">
                    <h2 class="text-center">No Data Found</h2>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
        <!-- ................. -->
        <pagination
          class="mx-6"
          :recordPerPage="recordPerPage"
          :total="total"
          @changePage="pageChange"
          v-if="!isEmpty"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="closeModal()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import config from "@/config.js";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import formats from "@/formats";
const pagination = () => import("@/views/common/Pagination");
const loader = () => import("@/components/loader.vue");
export default {
  components: {
    Datepicker,
    pagination,
    loader,
  },
  props: ["userId", "referredListDetails"],
  data() {
    return {
      details: this.referredListDetails,
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      dayJS,
      formats,
      search: "",
      showLoader: false,
      currentPage: 1,
      recordPerPage: 10,
      totalPage: 0,
      total: 0,
      dateRange: {
        start: "",
        end: "",
      },
      referencedUserList: [],
      isEmpty: false,
    };
  },
  mounted() {
    this.getReferredUserList();
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    dateChange() {
      this.getReferredUserList();
    },
    pageChange(page) {
      this.currentPage = page.currentPage;
      this.getReferredUserList();
    },
    getReferredUserList() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        start_date: this.dateRange.start.toString(),
        end_date: this.dateRange.end.toString(),
      };
      let url = `${config.BASE_URL}api/v2/admin/referenced-users/${this.userId}`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
            this.referencedUserList = response.body.data.list;
          } else {
            this.referencedUserList = [];
            this.currentPage = 1;
            this.isEmpty = true;
          }
        }
      });
    },
  },
};
</script>